export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "doimpo",
  url: "https://doimpo.com",
  logo: "https://doimpo.com/logos/logo.svg",
  description:
    "Strategy, brand, product, and marketing under one roof for teams in the US, UK, AU, and UAE. One partner. No vendor juggling.",
  sameAs: [
    "https://www.linkedin.com/company/doimpo",
    "https://www.instagram.com/doimpo_collab",
    "https://www.instagram.com/doimpo.studio",
    "https://www.facebook.com/doimpo",
  ],
  founder: {
    "@type": "Person",
    name: "David Enoch",
    url: "https://davidenoch.me",
    jobTitle: "Founder",
  },
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "sales",
    email: "hello@doimpo.com",
    url: "https://doimpo.com/book",
    areaServed: ["US", "GB", "AU", "Worldwide"],
    availableLanguage: ["English"],
  },
  address: {
    "@type": "PostalAddress",
    streetAddress: "Tower 6, 2710, My Home Tridasa",
    addressLocality: "Thellapur",
    addressRegion: "Hyderabad",
    postalCode: "502032",
    addressCountry: "IN",
  },
  areaServed: [
    { "@type": "Country", name: "United States" },
    { "@type": "Country", name: "United Kingdom" },
    { "@type": "Country", name: "Australia" },
    "Worldwide",
  ],
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "doimpo",
  url: "https://doimpo.com",
  description:
    "Strategy, brand, product, and marketing under one roof for teams in the US, UK, AU, and UAE. One partner. No vendor juggling.",
  publisher: {
    "@type": "Organization",
    name: "doimpo",
    logo: { "@type": "ImageObject", url: "https://doimpo.com/logos/logo.svg" },
  },
};
